// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderCustomerNotes_wrapper__jaukZ","notesTitle":"OrderCustomerNotes_notesTitle__7Xo+9","notes":"OrderCustomerNotes_notes__oQcG4"};